import {
  SearchSearchProductAttribute,
  SearchSearchProductsResponse,
} from '@winelivery-org/wl-client-sdk-js/src/models/search/product';
import { useTranslations } from 'next-intl';
import { ChevronRight as IconChevronRight } from '../../../../../../../components/icons';
import { Link } from '@/i18n/routing';

interface Props {
  suggestions: SearchSearchProductsResponse;
  onClick?: () => void;
}

export default function Locations({ suggestions, onClick }: Props) {
  const t = useTranslations('shop');

  function handleClick() {
    if (onClick) {
      onClick();
    }
  }

  function getLink(attribute: SearchSearchProductAttribute) {
    const queryString = attribute.parent
      ? `country=${attribute.parent.slug}&region=${attribute.slug}`
      : `country=${attribute.slug}`;

    return {
      href: `/shop?${queryString}`,
    };
  }

  if (
    suggestions.countries.items.length === 0 &&
    suggestions.regions.items.length === 0
  ) {
    return null;
  }

  const items = [
    ...suggestions.countries.items,
    ...suggestions.regions.items,
  ].sort((a, b) => {
    const first = a.parent ? `${a.parent.name} - ${a.name}` : a.name;
    const second = b.parent ? `${b.parent.name} - ${b.name}` : b.name;
    return first.localeCompare(second);
  });

  return (
    <div className="">
      <h5 className="text-lg text-greyscale-title font-bold tracking-tighter m-0">
        {t('search.locations')}
      </h5>
      <ul className="divide-y divide-greyscale-separator m-0 p-0">
        {items.map((attribute) => (
          <li key={attribute.id} className="-mx-4">
            {// @ts-expect-error
            <Link
              {...getLink(attribute)}
              className="cursor-pointer hover:bg-greyscale-background flex items-center py-2 px-4 text-greyscale-body no-underline hover:text-greyscale-body"
              onClick={handleClick}
            >
              <span className="flex-1 text-base text-font-medium tracking-tight leading-5 truncate">
                {attribute.parent
                  ? `${attribute.parent.name} - ${attribute.name}`
                  : attribute.name}
              </span>
              <IconChevronRight className="shrink-0 h-5" />
            </Link>}
          </li>
        ))}
      </ul>
    </div>
  );
}
